import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/auth";
import { useUserClientsData } from "../user-clients-data/user-clients-data";
import fileImg from "../assets/file.png"
import pdfImg from "../assets/pdf.png"
import excelImg from "../assets/excel.png"

// Libs
import Button from "../common/components/button";
import { primaryColor } from "../common/libs/theme-lib";

// Components
import moment from "moment";
import ClientSelector from "../common/components/client-selector";

// Actions 
import { readDocumentation, downloadDocumentation } from "../documentation/documentation-actions";

// Selectors 
import { documentationSelector } from "./documentation-selectors";

const documentationPageSelector = createSelector(
    documentationSelector,
    (documentation) => {
        documentation = documentation && documentation.toJS();
        documentation = (Array.isArray(documentation) && documentation) || [];
        return {
            documentation: documentation,
        }
    }
);

// Redux dispatch hook
const useReduxDispatch = () => {
    const dispatch = useDispatch();
    return {
        readDocumentation: (client) => dispatch(readDocumentation(client)),
        downloadDocumentation: (documentation, fileName) => dispatch(downloadDocumentation(documentation, fileName))
    }
};

const DocumentationPage = () => {

    const { selectedClient, userType } = useAuth();
    const { userClientsData } = useUserClientsData();
    const selectedClientData = userClientsData.find(client => client._id === selectedClient);

    const { documentation } = useSelector(state => documentationPageSelector(state));

    const { readDocumentation, downloadDocumentation } = useReduxDispatch();

    // This use effect executed one time
    useEffect(() => {
        readDocumentation({client : selectedClient});
    }, []);

    //i18n
    const {t} = useTranslation("documentation");

    return ( 
        <>
            <div style={{
                display: "flex",
                alignItems: "flex-end",
                paddingBottom: "15px",
            }}>
                <div style={{flex: 1}}>
                    <div style={{
                        color: primaryColor,
                        fontSize: 28,
                        fontWeight: "bold",
                        marginBottom: 10,
                    }}>
                        {t("title", { client: selectedClientData && selectedClientData.name } )}
                    </div>
                    <div style={{fontWeight: 100, fontSize: 18}}>
                        <span style={{fontWeight:"bold"}}>{documentation.length}</span>
                        <span>{" " + t("availableDocuments")}</span>
                    </div>
                </div>
                {userType === "admin" && (
                    <ClientSelector style={{marginRight: 0}} />
                )}
            </div>
            <div className="row">
                <div className="col-12" style={{maxHeight: 730, overflowY: "scroll"}}>
                    <div style={{display: 'flex',flexWrap: 'wrap'}}>
                        {documentation.map( doc => 
                            <div style={{
                                minWidth: "550px",
                                height: "370px",
                                backgroundColor: "white",
                                marginRight: "30px",
                                marginBottom: "30px"
                            }} key={doc._id}>
                                <div style={{ display: 'flex',flexWrap: 'wrap' }}>
                                    <img src={doc.extension === "PDF" ? pdfImg : doc.extension === "XLS" || doc.extension === "XLSX" ? excelImg : fileImg} style={{ width: "60px", height: "60px", margin: "30px 20px 40px 20px"}}/>
                                    <div style={{ marginTop: "30px", display: "flex", flexDirection: "column"}}>
                                        <span style={{ fontWeight: "bold", fontSize: 18, marginBottom: 10, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", boxSizing: "border-box", width: 430}} title={doc.name}>{doc.name}</span>
                                        <span style={{ fontWeight: 100, fontSize: 17, overflow: "hidden", whiteSpace: "nowrap", display: "-webkit-box ", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", whiteSpace: "normal", width: "400px"}} title={doc.description}>{doc.description}</span>
                                    </div>
                                </div>
                                <hr style={{ width: "500px", marginTop: 15, marginLeft: "25px" }}/>
                                    <div style={{ display: "flex", marginBottom: "15px"}}>
                                        <div style={{ textAlign: "right", width: 200}}>
                                            <span style={{ color: primaryColor, fontSize: 16, fontWeight: "bold", marginRight: "10px" }}>{t("document")}</span>
                                        </div>
                                        <span style={{ fontSize: 16, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", boxSizing: "border-box" , width: 300}} title={doc.fileName + " (" + doc.extension + ", " + (Math.trunc(doc.size/1024) + " KB)")}>{doc.fileName + " (" + doc.extension + ", " + (Math.trunc(doc.size/1024) + " KB)")}</span>
                                    </div>
                                    <div style={{ display: "flex"}}>
                                        <div style={{ textAlign: "right", width: 200}}>
                                            <span style={{ color: primaryColor, fontSize: 16, fontWeight: "bold", marginRight: "10px" }}>{t("startDate")}</span>
                                        </div>
                                        <span style={{ fontSize: 16 }}>{moment(doc.startDate).format("DD/MM/YYYY")}</span>
                                    </div>
                                    <div style={{ display: "flex", marginTop: 15}}>
                                        <div style={{ textAlign: "right", width: 200}}>
                                            <span style={{ color: primaryColor, fontSize: 16, fontWeight: "bold", marginRight: "10px" }}>{t("endDate")}</span>
                                        </div>
                                        <span style={{ fontSize: 16 }}>{moment(doc.endDate).format("DD/MM/YYYY")}</span>
                                    </div>
                                <Button
                                    text={t("download")}
                                    style={{width: "200px", marginLeft: "175px", marginTop: "30px", marginBottom: "30px"}}
                                    action={() => {
                                        downloadDocumentation(doc._id, doc.fileName);
                                    }}
                                    icon="download"
                                    intent={"red"}
                                    disabled={true}
                                />                               
                            </div>
                        )}                        
                    </div>
                </div>     
            </div>        
        </>
    );
};

export default DocumentationPage;

